import dayjs from 'dayjs';

var advancedFormat = require('dayjs/plugin/advancedFormat');
var isToday = require('dayjs/plugin/isToday');
dayjs.extend(isToday);
dayjs.extend(advancedFormat);

const HelperService = {};

HelperService.snakeToTitleCase = function (str) {
  if (!str) return null;
  return str
    .split('_')
    .map((word) => word[0].toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

HelperService.toTitleCase = function toTitleCase(str) {
  if (typeof str === 'string') {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  } else {
    return str;
  }
};

HelperService.toSnakeCase = function (str) {
  return (
    str &&
    str
      .match(
        /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g
      )
      .map((s) => s.toLowerCase())
      .join('_')
  );
};

HelperService.currency = function toTitleCase(number) {
  number = parseFloat(number);
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',

    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });

  if (Number.isFinite(number)) {
    return formatter.format(number);
  } else {
    return '';
  }
};

HelperService.percentage = (value) => {
  return `${value}%`;
};

HelperService.date = (date) => {
  if (date) {
    const d = dayjs(date);
    if (d.isToday()) {
      return d.format('HH:mm A');
    } else {
      return d.format('MMM Do');
    }
  } else {
    return '';
  }
};

HelperService.phone = (phone) => {
  if (phone) {
    return `(${phone.substring(0, 3)}) ${phone.substring(
      3,
      6
    )} - ${phone.substring(6)}`;
  }
  return '';
};

HelperService.userInitials = (customer) => {
  if (customer && customer.name) {
    if (customer.name.split(' ').length >= 2) {
      return `${customer.name.split(' ')[0].substring(0, 1)}${customer.name
        .split(' ')[1]
        .substring(0, 1)}`;
    } else {
      return customer.name.split(' ')[0].substring(0, 1);
    }
  }
  return '';
};

export default HelperService;
